import { render, staticRenderFns } from "./BtnInserirItem.vue?vue&type=template&id=62cff87e"
import script from "./BtnInserirItem.vue?vue&type=script&lang=js"
export * from "./BtnInserirItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports